import { render } from "./WaiverApproved.vue?vue&type=template&id=b4bf2a9e&scoped=true"
import script from "./WaiverApproved.vue?vue&type=script&lang=js"
export * from "./WaiverApproved.vue?vue&type=script&lang=js"

import "./WaiverApproved.vue?vue&type=style&index=0&id=b4bf2a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bf2a9e"]])

export default __exports__